import {useIntl} from 'react-intl';

import {view} from '@sail/ui';

import type {Conversation} from '@stripe-internal/conversations-client';

import {disclaimerMessages as messages} from '../../../core/messages';
import {
  useAudience,
  useCurrentConversation,
} from '../../../core/hooks/appHooks';
import {useLiveChannelStatus} from '../../support/hooks/useLiveChannelStatus';

export function ConversationDisclaimerContent({
  conversation,
}: {
  conversation: Conversation;
}) {
  const intl = useIntl();
  const {isLiveChatActive} = useLiveChannelStatus(conversation);

  if (isLiveChatActive) {
    return null;
  }

  return <DisclaimerText text={intl.formatMessage(messages.disclaimer)} />;
}

export function DisclaimerText({text}: {text: string}) {
  return (
    <view.div
      css={{
        stack: 'y',
        alignX: 'center',
        color: 'form.placeholder',
        font: 'label.small',
        flexGrow: 0,
        width: 'fill',
        paddingX: 'space.200',
        paddingBottom: 'space.200',
        zIndex: 2, // sit on top of background wave
      }}
    >
      <view.div
        css={{
          textAlign: 'center',
          width: 'fill',
        }}
      >
        {text}
      </view.div>
    </view.div>
  );
}

export const StripeAssistantDisclaimer = () => {
  const conversation = useCurrentConversation();
  const audience = useAudience();

  if (audience === 'link') {
    return null;
  }

  if (!conversation) {
    return null;
  }

  return <ConversationDisclaimerContent conversation={conversation} />;
};
